import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
// import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'callback/update-password',
    loadComponent: () =>
      import(
        './core/components/authentication/update-password/update-password.component'
      ).then((m) => m.UpdatePasswordComponent),
    data: { portalType: 'customer' }
  },
  {
    path: 'callback/partner-update-password',
    loadComponent: () =>
      import(
        './core/components/authentication/update-password/update-password.component'
      ).then((m) => m.UpdatePasswordComponent),
    data: { portalType: 'partner' }
  },
  {
    path: 'callback/sign-up',
    loadComponent: () =>
      import(
        './core/components/authentication/sign-up-activation/sign-up-activation.component'
      ).then((m) => m.SignUpActivationComponent),
  },
  {
    path: 'callback/generate-password',
    loadComponent: () =>
      import(
        './modules/company-contact-details/components/generate-password/generate-password.component'
      ).then((m) => m.GeneratePasswordComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import(
        './core/components/authentication/reset-password/reset-password.component'
      ).then((m) => m.ResetPasswordComponent),
    data: { portalType: 'customer' }
  },
  {
    path: 'partner-reset-password',
    loadComponent: () =>
      import(
        './core/components/authentication/reset-password/reset-password.component'
      ).then((m) => m.ResetPasswordComponent),
    data: { portalType: 'partner' }
  },
  {
    path: 'create-account',

    loadComponent: () =>
      import(
        './core/components/authentication/sign-up-create-account/sign-up-create-account.component'
      ).then((m) => m.SignUpCreateAccountComponent),
  },

  {
    path: 'create-account-existing',

    loadComponent: () =>
      import(
        './core/components/authentication/sign-up-create-account-existing/sign-up-create-account-existing.component'
      ).then((m) => m.SignUpCreateAccountExistingComponent),
  },

  {
    path: '',
    loadChildren: () =>
      import('./modules/customer-portal-home/customer-portal-home.route').then(
        (m) => m.CUSTOMER_PORTAL_LANDING_PAGE_ROUTES
      ),
  },
  {
    path: 'customer-portal',
    loadChildren: () =>
      import('./modules/customer-portal-home/customer-portal-home.route').then(
        (m) => m.CUSTOMER_PORTAL_LANDING_PAGE_ROUTES
      ),
  },
  {
    path: 'update-profile-details',
    loadComponent: () =>
      import(
        './modules/profile-details/components/update-profile-details/update-profile-details.component'
      ).then((m) => m.UpdateProfileDetailsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'ticket',
    loadChildren: () =>
      import('./modules/ticket-management/ticket-management.routes').then(
        (m) => m.TICKET_MANAGEMENT_ROUTES
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'active-services-plan',
    loadChildren: () =>
      import('./modules/active-services-plan/active-services-plans.route').then(
        (m) => m.ACTIVE_SERVICES_PLANS_PAGE_ROUTES
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'company-contact',
    loadChildren: () =>
      import('./modules/company-contact-details/company-contact.route').then(
        (m) => m.COMPANY_CONTACT_ROUTES
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'payment',
    loadChildren: () =>
      import('./modules/payment-details/payment-details.routes').then(
        (m) => m.PAYMENT_DETAILS_ROUTES
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice',
    loadChildren: () =>
      import('./modules/invoice-details/invoice.routes').then(
        (m) => m.INVOICE_ROUTES
      ),
      canActivate: [AuthGuard],
  },
  {
    path: 'product-registration',
    loadComponent: () =>
      import('./modules/product-registration/product-registration.component').then(
        (m) => m.ProductRegistrationComponent
      ),
      canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
